import { useEffect, useState } from "react";
import PageBanner from "../components/PageBanner";
import api from "../lib/api";
import SEO from "../lib/SEO";

export default function Flavours() {
    const [flavours, setFlavours] = useState([]);
    useEffect(() => {
        api.get("/flavours").then((r) => setFlavours(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    }, []);

    return (
        <main data-testid="flavours-page">
            <SEO
                title="Flavours — Cake Central"
                description="Explore Cake Central's bespoke cake flavours — from Madagascan vanilla to pistachio rose and salted caramel."
                path="/flavours"
            />
            <PageBanner
                eyebrow="Tasting menu"
                title="Our Flavours"
                image="https://images.unsplash.com/photo-1602663491496-73f07481dbea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
            />

            <section className="bg-[#FFF7FB] py-12 md:py-16">
                <div className="px-4 sm:px-6 lg:px-10">
                    <p className="text-center text-ink-soft max-w-2xl mx-auto mb-12 md:mb-14 leading-relaxed">
                        Every flavour is hand-crafted in our Sydney studio. Mix and match across tiers — most of
                        our wedding and celebration cakes feature two or more flavours.
                    </p>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 md:gap-3 max-w-screen-2xl mx-auto">
                        {flavours.map((f, i) => (
                            <article
                                key={f.id}
                                className="card-lift bg-white border border-[#EAE3DE]"
                                data-testid={`flavour-card-${i}`}
                            >
                                <div className="aspect-square overflow-hidden">
                                    <img
                                        src={f.image_url}
                                        alt={f.name}
                                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="p-4">
                                    <h3 className="font-display text-lg text-ink mb-1">{f.name}</h3>
                                    <p className="text-sm text-ink-soft leading-snug line-clamp-3">
                                        {f.description}
                                    </p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
}
